import styled from "styled-components";

export const Step = styled.div<{isActive: boolean}>`
  display: ${({isActive}) => isActive ? 'block' : 'none'};
  padding: 100px 200px;
  width: 100%;
  height: 100%;
  background: ${({theme}) => theme.business.colors.primaryBackground};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 800px;
`

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 150px;
  flex-basis: 600px;
`

export const CrossedText = styled.span`
  text-decoration: line-through;
  color: rgba(255, 255, 255, 0.5);
`